export const SET_WEBSHOP_INFO_CONFIG = 'SET_WEBSHOP_INFO_CONFIG'
export const SET_WEBSHOP_APP_CONFIG = 'SET_WEBSHOP_APP_CONFIG'
